import React, { ReactNode } from "react";

type SidebarTypes = {
  title: string;
  children?: ReactNode;
  fitContent?: boolean;
};

function Sidebar({ title, children, fitContent = true }: SidebarTypes) {
  return (
    <div className={`px-3 sm:px-5 lg:px-8 w-full ${fitContent ? "h-fit" : "h-full"}`}>
      <div className="bg-white w-full shadow-md pb-8 px-3 sm:px-4 lg:px-6 h-full flex flex-col gap-4 lg:gap-6 overflow-y-auto pt-5">
        <div className="border-b-1 h-14 w-[3/5] flex items-center justify-center ">
          <p className="text-lg text-center block pb-2 font-semibold">
            {title}
          </p>
        </div>

        {children}
      </div>
    </div>
  );
}

export default Sidebar;
